import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the view for partner products table.
 * @extends JetView
 */
export default class tablePartnersProductsView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating', // Column ID
                                    header: '', // Column header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    template: function (obj) {
                                        // Template function for rendering
                                        if (devConfig.getPermAction('partnersTypeProductEdit', 'Edit')) {
                                            return "<span class='webix_icon wxi-close edit'></span>"; // Edit icon if permission granted
                                        } else {
                                            return ''; // No icon if permission denied
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 50, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Partner', // Column ID
                                    header: 'Partner', // Column header
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Column ID
                                    header: _('Tipo'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'SiteId', // Column ID
                                    header: _('Site ID'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Key', // Column ID
                                    header: _('Clave'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Url', // Column ID
                                    header: _('URL API'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'TypeIntegration', // Column ID
                                    header: _('Tipo de integración'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        {
                                            id: '0',
                                            value: _('Lobby con token propio'),
                                        },
                                        {
                                            id: '1',
                                            value: _('Lobby con token de proveedor'),
                                        },
                                        { id: '2', value: _('Productos') },
                                    ],
                                    width: 120, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Contingency', // Column ID
                                    header: _('Contingencia'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 120, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    $$('editwinPartnerProducts').show(); // Show edit window
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            // Data source URL for the datatable
                            url:
                                devConfig.geturlApi() +
                                'PartnersProducts/GetPartnersTypeProduct?Partner=' +
                                id_partner +
                                '&',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = grid.data.url; // URL for data loading
        var cthis = this; // Reference to the current context
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        var providers = []; // Array to hold provider data
        var popup = webix.ui({
            // Popup window for editing partner products
            view: 'window',
            id: 'editwinPartnerProducts', // ID for the edit window
            width: screen.width < 500 ? 350 : 450, // Width based on screen size
            height: screen.width < 500 ? 680 : 580, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                // Header configuration
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar Partner') }, // Label for editing partner
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center the popup
            modal: false, // Non-modal window
            body: {
                // Body configuration
                view: 'scrollview',
                scroll: 'y', // Enable vertical scrolling
                body: {
                    view: 'form', // Form for editing partner product details
                    id: 'editform', // ID for the edit form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    height: screen.width < 500 ? 680 : 530, // Height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'text',
                            label: 'Id', // Label for ID field
                            name: 'Id', // Field name
                            labelWidth: 150, // Label width
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'combo', // Combo box for activation status
                            label: _('Estado'), // Label with localization
                            name: 'IsActivate', // Field name
                            labelWidth: 150, // Label width
                            options: [
                                // Options for the combo editor
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'text', // Text field for Site ID
                            label: _('Site ID'), // Label with localization
                            name: 'SiteId', // Field name
                            attributes: { type: 'number' }, // Input type
                            labelWidth: 150, // Label width
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'text', // Text field for Key
                            label: _('Clave'), // Label with localization
                            name: 'Key', // Field name
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'text', // Text field for API URL
                            label: _('URL API'), // Label with localization
                            name: 'Url', // Field name
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'checkbox', // Checkbox for changing key
                            label: _('KEY'), // Label with localization
                            name: 'ChangeKey', // Field name
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'combo', // Combo box for integration type
                            label: _('Tipo de integración'), // Label with localization
                            name: 'TypeIntegration', // Field name
                            labelWidth: 150, // Label width
                            options: [
                                // Options for the combo editor
                                { id: '0', value: _('Lobby con token propio') },
                                {
                                    id: '1',
                                    value: _('Lobby con token de proveedor'),
                                },
                                { id: '2', value: _('Productos') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'combo', // Combo box for contingency status
                            label: _('Contingencia'), // Label with localization
                            name: 'Contingency', // Field name
                            labelWidth: 150, // Label width
                            options: [
                                // Options for the combo editor
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            margin: 10, // Margin for the next element
                            cols: [
                                {
                                    view: 'text', // Text field for explanation
                                    labelPosition: 'top', // Label position
                                    label: _('Explicación'), // Label with localization
                                    name: 'Note', // Field name
                                    labelWidth: 160, // Label width
                                    attributes: { type: 'text' }, // Input type
                                },
                            ],
                        },
                        {
                            cols: [
                                // Buttons for cancel and save actions
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'), // Button label with localization
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide the popup on cancel
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form', // Button type
                                    value: _('Guardar'), // Button label with localization
                                    click: function ($e) {
                                        var values = $$('editform').getValues(); // Get form values
                                        values.Partner = id_partner; // Add partner ID to values
                                        var c2this = this; // Reference to the current context
                                        webix
                                            .ajax() // AJAX request to save changes
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnerProduct/UpdatePartnerTypeProduct',
                                                values, // Data to send
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Show error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message(
                                                                'Error: ' + text.AlertMessage, // Show error message if any
                                                            );
                                                        } else {
                                                            $$('editform').clear(); // Clear the form
                                                            c2this.getTopParentView().hide(); // Hide the popup
                                                            webix.message(
                                                                _(
                                                                    'Tipo Producto Partner Editado', // Show success message
                                                                ),
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var popupAdd = webix.ui({
            // Popup window for adding partner products
            view: 'window',
            id: 'AddPartnerProducts', // ID for the add window
            width: screen.width < 500 ? 350 : 450, // Width based on screen size
            height: screen.width < 500 ? 650 : 350, // Height based on screen size
            fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
            head: {
                // Header configuration
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Añadir Tipo Producto Partner') }, // Label for adding partner product
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center the popup
            modal: true, // Modal window
            body: {
                // Body configuration
                view: 'scrollview',
                scroll: 'y', // Enable vertical scrolling
                body: {
                    view: 'form', // Form for adding partner product details
                    id: 'addform', // ID for the add form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    height: screen.width < 500 ? 650 : 300, // Height based on screen size
                    elements: [
                        // Form elements
                        {
                            view: 'combo', // Combo box for product type
                            label: _('Tipo'), // Label with localization
                            name: 'Type', // Field name
                            value: 'CASINO', // Default value
                            labelWidth: 150, // Label width
                            options: [
                                // Options for the combo editor
                                { id: 'CASINO', value: _('Casino') },
                                {
                                    id: 'PAYMENT',
                                    value: _('Pasarela de Pagos'),
                                },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'combo', // Combo box for activation status
                            label: _('Estado'), // Label with localization
                            name: 'IsActivate', // Field name
                            value: 'A', // Default value
                            labelWidth: 150, // Label width
                            options: [
                                // Options for the combo editor
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'text', // Text field for API URL
                            label: _('URL API'), // Label with localization
                            name: 'Url', // Field name
                            labelWidth: 150, // Label width
                            value: '', // Default value
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'combo', // Combo box for integration type
                            label: _('Tipo de integración'), // Label with localization
                            name: 'TypeIntegration', // Field name
                            labelWidth: 150, // Label width
                            options: [
                                // Options for the combo editor
                                { id: '0', value: _('Lobby con token propio') },
                                {
                                    id: '1',
                                    value: _('Lobby con token de proveedor'),
                                },
                                { id: '2', value: _('Productos') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            view: 'combo', // Combo box for contingency status
                            label: _('Contingencia'), // Label with localization
                            name: 'Contingency', // Field name
                            labelWidth: 150, // Label width
                            options: [
                                // Options for the combo editor
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                        },
                        {
                            cols: [
                                // Buttons for cancel and save actions
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'), // Button label with localization
                                    click: function () {
                                        this.getTopParentView().hide(); // Hide the popup on cancel
                                        $$('addform').clear(); // Clear the form
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form', // Button type
                                    value: _('Guardar'), // Button label with localization
                                    click: function ($e) {
                                        var values = $$('addform').getValues(); // Get form values
                                        values.Partner = id_partner; // Add partner ID to values
                                        var c2this = this; // Reference to the current context
                                        webix
                                            .ajax() // AJAX request to save new partner product
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'PartnerProduct/CreatePartnerTypeProduct',
                                                values, // Data to send
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Show error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        text = JSON.parse(text); // Parse response
                                                        if (text.HasError) {
                                                            webix.message(
                                                                'Error: ' + text.AlertMessage, // Show error message if any
                                                            );
                                                        } else {
                                                            $$('addform').clear(); // Clear the form
                                                            c2this.getTopParentView().hide(); // Hide the popup
                                                            webix.message(
                                                                _(
                                                                    'Tipo Producto Partner Agregado', // Show success message
                                                                ),
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        this.on(this.app, 'addProductPartner:button', (filter) => {
            popupAdd.show(); // Show add product popup
            var optionsCountries = $$('AddProvider').getList(); // Get list of providers
            optionsCountries.clearAll(); // Clear existing options
            optionsCountries.parse(providers); // Parse new provider data
        });
        var filter = ''; // Initialize filter variable
        this.on(this.app, 'partnerProducts:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Partner=' + id_partner; // Add partner ID to query
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event handler for player selection
            grid.load(
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Event handler for double-click
            var item = this.getItem(id); // Get double-clicked item
            popup.show(); // Show edit popup
        });
        $$('editform').bind($$('datatable')); // Bind edit form to datatable
        webix
            .ajax() // AJAX request to fetch product providers
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Providers/GetProductProviders', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize response keys
                            .replace(/"Name"/g, '"value"'),
                    );
                    console.log(data); // Log fetched data
                    providers = data.Data; // Store provider data
                },
            });
    }
}

// FILE DOCUMENTED
